const check = /(http|https):\/\/(www\.|)(gigplanet\.no)/

const isExternalLink = href => !check.test(href)

export default isExternalLink
